import { useEffect, useState } from 'react'

export const useAnyElementInViewport = (ids, topOffset = 0) => {
  const [isAnyElementInViewport, setIsAnyElementInViewport] = useState(false)
  const idsKey = ids.join('|')

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const anyInViewport = entries.some((entry) => entry.isIntersecting)
        setIsAnyElementInViewport((prev) =>
          prev === anyInViewport ? prev : anyInViewport
        )
      },
      {
        root: null,
        rootMargin: `-${topOffset}px 0px 0px 0px`,
        threshold: 0,
      }
    )

    ids.forEach((id) => {
      const element = document.getElementById(id)
      if (element) {
        observer.observe(element)
      }
    })

    return () => {
      observer.disconnect()
    }
    // idsKey stabilizes inline array literals passed from headers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsKey, topOffset])

  return isAnyElementInViewport
}
